import React, { useContext, useEffect, useState } from 'react'
import styles from '../styles/modal.module.css'
import StateContext from '../context/state/StateContext'
import UserContext from '../context/user/UserContext'
import axios from 'axios'
import { toast } from 'react-toastify'

const ProfileUpdate = (props) => {

    const { confirm, setConfirm, userUpdateId, setUserUpdateId, setLoading} = useContext(StateContext)
    const { getEmployees } = useContext(UserContext);

    const token = localStorage.getItem("token")

    const [formData, setFormData] = useState({ name: "", username: "", email: "", phone: "", password: "" })
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading({ open: true, text: 'Updating...' })

            const response = await fetch(process.env.REACT_APP_API_URL + `api/auth/updateUser/${userUpdateId}`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${token}`
                },
                body: JSON.stringify(formData)
            })

            const json = await response.json();
            if (json.success) {
                toast.success(json.message)
                setFormData({ ...formData, name: json.data.name, username: json.data.username, email: json.data.email, phone: json.data.phone })
                getEmployees()
            } else {
                toast.error(json.error || json.message)
            }

        } catch (e) {

        }
        finally {
            setLoading({ open: false, text: '' })
            props.close({ open: false, component: '' })
        }
    }

    const setUserData = async () => {
        try {
            setLoading({ open: true, text: 'Updating...' })
            const response = await axios.get(process.env.REACT_APP_API_URL + `api/auth/getById/${userUpdateId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${token}`
                },
            })

            const json = response.data;
            if (json.success) {
                setFormData({ ...formData, name: json.user.name, username: json.user.username, email: json.user.email, phone: json.user.phone })
            } else {
                toast.error(json.error || json.message)
            }

        } catch (error) {
            console.log(error);
        }finally {
            setLoading({ open: false, text: '' })
            
        }
    }
    useEffect(() => {
        if (userUpdateId) {
            setUserData()
        }
    },
        [userUpdateId])

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    return (
        <>
            <div className={styles.head}>
                <h4>Profile Update</h4>
                <i className={`bx bx-x ${styles.close}`} onClick={() => props.close({ open: false, component: '' })}></i>
            </div>
            <div className="text-center">
                <h4>{confirm.text}</h4>
            </div>
            <form className='h-100' onSubmit={handleSubmit}>
                <div className={styles.form_container}>
                    <div className="row">
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="text" name='name' value={formData.name} placeholder='Enter a name' onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="text" name='username' value={formData.username} placeholder='Enter a username' onChange={handleChange} required />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="email" name='email' value={formData.email} placeholder='Enter an Email' onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="text" name='phone' value={formData.phone} placeholder='Enter a phone number' onChange={handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd", position: 'relative' }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    value={formData.password}
                                    placeholder="Enter a password"
                                    onChange={handleChange}
                                    style={{ width: "100%", paddingRight: "40px" }} // Add space for the eye icon
                                />  
                                <span
                                    onClick={togglePasswordVisibility}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        zIndex: '99999'
                                    }}
                                >
                                    {showPassword ? '👁️' : '👁️‍🗨️'} {/* Eye icon */}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.foot}>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                        <button type='button' className="button2 cancel" onClick={() => props.close({ open: false, component: '' })}>Cancel</button>
                        <button type='submit' className={`button2`} >Confirm</button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default ProfileUpdate
